import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'role',
    serviceName: 'shopadmin',
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          total
          last_page
          data {
            id
            title
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteRole',
    serviceName: 'admin',
    query: gql`
      mutation deleteRole($ids: [String]!) {
        deleteRole(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'role',
    serviceName: 'shopadmin',
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'role',
    serviceName: 'shopadmin',
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
